import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';

class Formulariovendedores extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Vendedores",
            msg: 0,
            comp: "",
            id_vendedores: "",
            empresa: currentCompany,
            codigo: "",
            nombre: "",
            cedula: "",
            tope_dscto: 0,
            estado: "1",
            post: "",
            postf: "",
            bodega: "",
            pedido: "",
            forma_pago: 0,
            MOSTRAR_PREFIJO: 0,
            docPost: [],
            docPostFE: [],
            bodegas: [],
            pedidos: [],
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: ""
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_vendedores = "";
        const vendedorEdicion = search.replace('?', '');
        if (vendedorEdicion) {
            titulo = "Modificar Vendedores";
            id_vendedores = vendedorEdicion;
        } else {
            titulo = "Crear Vendedores";
            id_vendedores = "-";
        }
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/seller/' + id_vendedores, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    //console.log(datos[4]);
                    const vendedor = datos[0];
                    const post = datos[1];
                    const postFact = datos[2];
                    const bodegas = datos[3];
                    const pedidos = datos[4];
                    if (vendedor.length > 0) {
                        this.setState({
                            codigo: vendedor[0]["CODIGO_VENDEDORES"],
                            nombre: vendedor[0]["NOMBRE_VENDEDOR"],
                            estado: vendedor[0]["ESTADO"],
                            cedula: vendedor[0]["CEDULA"],
                            post: vendedor[0]["POST"],
                            postf: vendedor[0]["POSTFE"],
                            bodega: vendedor[0]["BODEGA"],
                            pedido: vendedor[0]["PEDIDO"],
                            tope_dscto: vendedor[0]["TOPE_DSCTO"],
                            forma_pago: vendedor[0]["FORMA_PAGO"],
                            MOSTRAR_PREFIJO: vendedor[0]["MOSTRAR_PREFIJO"],
                            docPost: post,
                            docPostFE: postFact,
                            bodegas,
                            pedidos
                        });
                    } else {
                        this.setState({
                            codigo: "",
                            nombre: "",
                            estado: "1",
                            cedula: "",
                            post: "",
                            postf: "",
                            tope_dscto: 0,
                            docPost: post,
                            docPostFE: postFact,
                            bodegas,
                            pedidos
                        });
                    }

                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });

        this.setState({ id_vendedores, titulo });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { empresa } = this.state;
        const { codigo } = this.state;
        const { nombre } = this.state;
        const { estado } = this.state;
        const { cedula } = this.state;
        const { post } = this.state;
        const { postf } = this.state;
        const { bodega } = this.state;
        const { pedido } = this.state;
        const { tope_dscto } = this.state;
        const { forma_pago } = this.state;
        const { MOSTRAR_PREFIJO } = this.state;
        //console.log(MOSTRAR_PREFIJO);

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                codigo,
                nombre,
                estado,
                cedula,
                post,
                postf,
                bodega,
                pedido,
                tope_dscto,
                forma_pago,
                MOSTRAR_PREFIJO
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_vendedores === "-") {
            ruta = config.servBackEnd + '/seller/create';
        } else {
            ruta = config.servBackEnd + '/seller/modify/' + this.state.id_vendedores;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoVendedor = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_vendedores;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_vendedores: nuevoVendedor })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Vendedores con errores:" + errores[data.code] + " " + data.message })
                }
            });
        event.preventDefault();
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const mensajeBoton = (this.state.id_vendedores === "-") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_vendedores === "-") ? '¿Esta seguro que desea crear el vendedor?' : '¿Esta seguro que desea modificar el vendedor?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const { docPost } = this.state;
        const { docPostFE } = this.state;
        const { bodegas } = this.state;
        const { pedidos } = this.state;
        //console.log(pedidos);
        return (
            <div className="Formulariovendedores">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Vendedores!</Tooltip>}>
                            <div className="div-back">
                                <a href="/vendedores/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Codigo</Form.Label>
                                            <Form.Control type="text" maxLength="4" placeholder="codigo" onChange={e => this.setState({ codigo: e.target.value.toUpperCase() })} value={this.state.codigo} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Nombre</Form.Label>
                                            <Form.Control type="text" placeholder="codigo" onChange={e => this.setState({ nombre: e.target.value.toUpperCase() })} value={this.state.nombre} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Cedula</Form.Label>
                                            <Form.Control type="text" placeholder="cedula" onChange={e => this.setState({ cedula: e.target.value.toUpperCase() })} value={this.state.cedula} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Tope Descuento</Form.Label>
                                            <Form.Control type="number" max="100" step="0.1" maxLength="4" onChange={e => this.setState({ tope_dscto: e.target.value })} value={this.state.tope_dscto} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Cambiar Forma Pago</Form.Label>
                                            <Form.Control as="select" placeholder="codigo" onChange={e => this.setState({ forma_pago: e.target.value })} value={this.state.forma_pago} required >
                                                <option value="1">Si</option>
                                                <option value="0">No</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Factura POST</Form.Label>
                                            <Form.Control as="select" placeholder="codigo" onChange={e => this.setState({ post: e.target.value })} value={this.state.post}  >
                                                <option value="">Seleccione</option>
                                                {
                                                    docPost.map((doc, i) => {
                                                        return (<option key={'p' + i} value={doc.PREFIJO}>{doc.PREFIJO}</option>)
                                                    })
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Factura Electronica POST </Form.Label>
                                            <Form.Control as="select" placeholder="codigo" onChange={e => this.setState({ postf: e.target.value })} value={this.state.postf}  >
                                                <option value="">Seleccione</option>
                                                {
                                                    docPostFE.map((doc, i) => {
                                                        return (<option key={'pf' + i} value={doc.PREFIJO}>{doc.PREFIJO}</option>)
                                                    })
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Bodega Factura POS</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ bodega: e.target.value })} value={this.state.bodega} >
                                                <option value="0">Seleccione</option>
                                                {
                                                    bodegas.map((bodega, i) => {
                                                        return (<option key={'b' + i} value={bodega.ID_BODEGAS}>{bodega.DESCRIPCION_BODEGA}</option>)
                                                    })
                                                }
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Documento para pedidos</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ pedido: e.target.value })} value={this.state.pedido} >
                                                <option value="0">Seleccione</option>
                                                {
                                                    pedidos.map((ped, i) => {
                                                        return (<option key={'b' + i} value={ped.PREFIJO}>{ped.PREFIJO}</option>)
                                                    })
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Estado</Form.Label>
                                            <Form.Control as="select" placeholder="codigo" onChange={e => this.setState({ estado: e.target.value })} value={this.state.estado} required >
                                                <option value="1">Activo</option>
                                                <option value="0">Inactivo</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group style={{ width: 250 }} controlId="">
                                            <Form.Label>Mostrar prefijos</Form.Label>
                                            <Form.Control as="select" placeholder="codigo" onChange={e => this.setState({ MOSTRAR_PREFIJO: e.target.value })} value={this.state.MOSTRAR_PREFIJO} required >
                                                <option value="1">SI</option>
                                                <option value="0">NO</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>

                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formulariovendedores);